import { render, staticRenderFns } from "./ordersListTableL2.vue?vue&type=template&id=41d2df87&scoped=true"
import script from "./ordersListTableL2.vue?vue&type=script&lang=js"
export * from "./ordersListTableL2.vue?vue&type=script&lang=js"
import style0 from "./ordersListTableL2.vue?vue&type=style&index=0&id=41d2df87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d2df87",
  null
  
)

export default component.exports